import { Action } from 'redux';

import { IContentInfo } from '../../../ts/models/IContentInfo';
import { MoveContents, MoveContentsSucceeded } from '../AppActionTypes';
import { isActionFactory } from '../isActionFactory';

export interface MoveContentsAction extends Action {
  contentArray: IContentInfo[];
}

export function moveContents(contentArray: IContentInfo[]): MoveContentsAction {
  return {
    type: MoveContents,
    contentArray: contentArray
  };
}

export const isMoveContentAction = isActionFactory<MoveContentsAction>(MoveContents);

export interface MoveContentsSucceededAction extends Action {}

export function moveContentsSucceeded(): MoveContentsSucceededAction {
  return {
    type: MoveContentsSucceeded
  };
}

export const isMoveContentSuceededAction = isActionFactory<MoveContentsSucceededAction>(MoveContentsSucceeded);
